/**
 * Shared constants and utilities for Sourcing Lab stages
 */

// Session stages
export const STAGES = {
    JOB_BRIEFING: 'job_briefing',
    SEARCH_STRATEGY: 'search_strategy',
    CANDIDATE_REVIEW: 'candidate_review',
    AI_DISCUSSION: 'ai_discussion',
    COMPLETED: 'completed'
};

// Difficulty colors
export const difficultyColors = {
    beginner: 'bg-emerald-500/10 text-emerald-600 border-emerald-500/30',
    intermediate: 'bg-blue-500/10 text-blue-600 border-blue-500/30',
    advanced: 'bg-amber-500/10 text-amber-600 border-amber-500/30',
    expert: 'bg-red-500/10 text-red-600 border-red-500/30'
};

// Stage order for progression
export const STAGE_ORDER = [
    STAGES.JOB_BRIEFING, 
    STAGES.SEARCH_STRATEGY, 
    STAGES.CANDIDATE_REVIEW, 
    STAGES.AI_DISCUSSION, 
    STAGES.COMPLETED
];
